import Backbone from "backbone";
import inject from "scripts/ioc/inject";
import RecentCollection from "scripts/collections/recentCollection";
import BreadcrumbModel from "scripts/models/breadcrumbModel";
import BaseView from "scripts/views/baseView";
import MediaSalvattoreGridView from "scripts/views/mediaSalvattoreGridView";
import MediaListView from "scripts/views/mediaListView";
import StackedMediaTypesChartView from "scripts/views/stackedMediaTypesChartView";
import { getCurrentFragment } from "scripts/utils/routerHelpers";

import templateRecentsSubPage from "templates/recentsSubPage.hbs";

class RecentsSubPageView extends BaseView {
  constructor(options, securityService = inject("securityService")) {
    super(options);

    this.securityService = securityService;

    const user = this.securityService.getUser();

    this.collection = new RecentCollection([], {
      path: `/users/${user.getUserId()}/recent-usage`,
      queryStringParams: {
        limit: 20,
      },
    });

    this.stackedMediaTypesChartView = this.addSubView(
      new StackedMediaTypesChartView({
        model: new Backbone.Model(),
      }),
    );

    if (this.model.get("presentationType") === "masonry") {
      this.contentView = this.addSubView(
        new MediaSalvattoreGridView({
          collection: this.collection,
        }),
      );
    } else {
      this.contentView = this.addSubView(
        new MediaListView({
          collection: this.collection,
        }),
      );
    }
  }

  get template() {
    return templateRecentsSubPage;
  }

  render() {
    console.log(this.collection.mediaTypePercentages());

    let chartModel = this.stackedMediaTypesChartView.model;
    chartModel.set("includeAnthology", true);
    chartModel.set(this.collection.mediaTypePercentages());

    const title =
      this.collection.length === 1
        ? "1 Recent"
        : this.collection.length + " Recents";

    this.$el.html(
      this.template({
        title: title,
      }),
    );

    this.stackedMediaTypesChartView
      .appendTo($("#bb-recents-sub-page-chart-region"))
      .render();

    this.contentView
      .appendTo($("#bb-recents-sub-page-content-region"))
      .render();

    return this;
  }

  sync() {
    return this.collection.fetch();
  }

  getBreadcrumbInfo() {
    return {
      breadcrumbModel: new BreadcrumbModel({
        text: "Recents",
        path: "#" + getCurrentFragment(),
        topLevel: true,
      }),
    };
  }

  getDocumentTitle() {
    return "Recents";
  }
}

export default RecentsSubPageView;
